import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import Agree from "../components/Agree";
import GroupParticipantForm from "../components/GroupParticipantForm";
import ParticipantForm from "../components/ParticipantForm";
import Payment from "../components/Payment";
import ProgressBar from "../components/ProgressBar";

const Apply = ({ history }) => {
  const [nowProcess, setNowProcess] = useState(1); //1.약관동의 2.참가신청 3.확정 및 결제 4.결제 확인
  const [res, setRes] = useState({});
  const [ticketInfo, setTicketInfo] = useState([]);
  const { pathname } = useLocation();
  const [ticketType, setTicketType] = useState();
  const [title, setTitle] = useState();
  const [path, setPath] = useState("");

  useEffect(() => {
    setPath(pathname.split("/")[2]);
    setTicketType("offline");
    if (path === "individual") {
      setTitle("개인 신청");
    } else if (path === "group") {
      setTitle("단체 신청(2인 이상)");
    }
    setNowProcess(1);
  }, [pathname, path]);
  if (nowProcess === 1)
    //약관 동의
    return (
      <Container>
        <h1 className="mt-3 mb-3">{title}</h1>
        <ProgressBar nowProcess={nowProcess} />
        <Agree
          setNowProcess={setNowProcess}
          setTicketInfo={setTicketInfo}
          ticketType={ticketType}
        />
      </Container>
    );
  else if (nowProcess === 2 && path === "group")
    //단체 신청
    return (
      <Container>
        <h1 className="mt-3 mb-3">{title}</h1>
        <ProgressBar nowProcess={nowProcess} />
        <GroupParticipantForm
          setNowProcess={setNowProcess}
          ticketInfo={ticketInfo}
          setRes={setRes}
        />
      </Container>
    );
  else if (nowProcess === 2) {
    //개인 신청
    return (
      <Container>
        <h1 className="mt-3 mb-3">{title}</h1>
        <ProgressBar nowProcess={nowProcess} />
        <ParticipantForm
          setNowProcess={setNowProcess}
          ticketInfo={ticketInfo}
          setRes={setRes}
        />
      </Container>
    );
  } else if (nowProcess === 3)
    //접수 확인
    return (
      <Container>
        <h1 className="mt-3 mb-3">{title}</h1>
        <ProgressBar nowProcess={nowProcess} />
        <Payment
          setRes={setRes}
          res={res}
          ticketInfo={ticketInfo}
          history={history}
          title="접수 확인 및 결제"
        />
      </Container>
    );
};
export default Apply;
